<template>
  <div>
    <h2 class="question-title">
      {{ question.title }}
    </h2>
    <div class="survey-progress-container">
      <div class="survey-progress-background" />
      <div
        id="survey-progress-bar"
        class="survey-progress-bar"
        data-testid="survey-progress-bar"
        :style="{ width: progress }"
      />
    </div>
    <div class="subtitle">
      <!-- eslint-disable vue/no-v-html -->
      <p
        class="question"
        v-html="question.question"
      />
    </div>
    <ul class="option-list">
      <li
        v-for="item in sortedOptions"
        :key="item.slug"
        class="question-option"
      >
        <label
          class="question-option"
          data-testid="question-label"
          :for="item.slug"
        >
          <input
            :id="item.slug"
            v-model="checkedValues"
            class="question-option"
            data-testid="question-input"
            :type="isMultiple ? 'checkbox' : 'radio'"
            :value="item.slug"
            @click="checkParentLabel"
          >
          <span class="question-option"> {{ item.option }} </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Question',
  components: {
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    checkedOptions: {
      type: [Array, String],
      required: false,
      default() {
        return [];
      },
    },
    progress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      checkedValues: this.checkedOptions,
    };
  },
  computed: {
    isMultiple() {
      return this.question.question_type === 'multiple';
    },
    sortedOptions() {
      const { options } = this.question;
      return options.sort((a, b) => a.order - b.order);
    },
  },
  watch: {
    checkedValues() {
      this.$emit('selectOption', this.checkedValues);
    },
    checkedOptions() {
      this.checkedValues = this.checkedOptions;
    },
  },
  methods: {
    checkParentLabel(event) {
      const eleNode = event.target.parentNode;
      const eleClass = eleNode.className;
      eleNode.className = (eleClass === 'question-option') ? 'question-option checked' : 'question-option';
      // make sure that other radio button stylings are reset
      if (event.target.type === 'radio') {
        // the selector method will return a dynamically updated list,
        // making a copy to avoid concurrent modification
        const labelList = document.getElementsByClassName('question-option checked');
        let index = 0;
        while (labelList.length > 1) {
          if (index === 0 && labelList[index] === eleNode) {
            index = 1;
          }
          labelList[index].className = 'question-option';
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../variables.scss";

  h2, b, p, label {
    color : #272727;
  }
  .subtitle {
    font-size: 14px;
    line-height: 150%;
  }
  .option {
    font-size: 12px;
    line-height: 12px;
    color: #4F5A68;
    margin: 10px 0px;
    padding-left: 18px;
  }
  div.survey-progress-container {
    margin: 25px 0px;
  }
  div.survey-progress-background {
    position: relative;
    z-index: 100;
    border-top: solid 2px #CCCCCC;
  }
  div.survey-progress-bar {
    position: relative;
    z-index: 200;
    width: 0%;
    border-top: solid 2px #0275D8;
    margin-top: -2px;
  }
  ul.option-list {
    list-style-type: none;
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
    padding: 0px;
    margin: 0px;
  }
  label.question-option {
    font-size: 14px;
    line-height: 14px;
    display: block;
  }
  li.question-option {
    margin-bottom: 19px;
  }
  input.question-option, span.question-option {
    vertical-align: middle;
  }
  input.question-option, input[type="checkbox"]::before, input[type="checkbox"]::after {
    border: solid 1px #E5E5E9;
    margin: 0px 10px 0px 0px;
    background: #FFFFFF;
    border-radius: 3px;
    width: 14px;
    height: 14px;
    box-sizing: border-box;
    position: relative;
    left: 0px;
    visibility: visible;
    opacity: 1;
  }
  h2.question-title {
    margin: 0px;
    font-size: 24px;
    line-height: 24px;
  }
  p.question-intro {
    display: block;
    color: #4F5A68;
    margin: 0px;
  }
  p.question {
    margin: 30px 0px;
  }

  @media screen and (max-width: $license-modal-mobile) {
    ul.option-list {
      columns: 1;
      -webkit-columns: 1;
      -moz-columns: 1;
    }
    h2.question-title {
      font-size: 20px;
      line-height: 125%;
    }
    div.survey-progress-container {
      margin: 13px 0px 20px 0px;
    }
    p.question-intro {
      display: none;
    }
    p.question {
      margin-top: 0px;
    }
    label.question-option {
      background: #FFFFFF;
      color: #272727;
      font-weight: 500;
      padding: 14px 10px;
      border: 1px solid #EEEEEE;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      border-radius: 3px;
    }
    label.checked {
      background: #0275D8;
      color: #FFFFFF;
      font-weight: 600;
    }
    label.checked > input.question-option {
      outline: solid 1px #FFFFFF;
    }
  }
</style>
